import { Button, Flex } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { IconDashboard } from 'wg-fe-ui';
import useTracking from '../../../../common/src/hooks/tracking/useTracking';

const SignedOfferBottomContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { trackEvent } = useTracking();

  const handleClick = () => {
    trackEvent('To Dashboard from Sales Conversation');
    history.push('/dashboard');
  };

  return (
    <Flex justify={{ base: 'center', mobileL: 'flex-end' }} w="100%">
      <Button
        leftIcon={<IconDashboard color="white" />}
        borderRadius="full"
        size="lg"
        onClick={handleClick}
      >
        {t('Go back to dashboard')}
      </Button>
    </Flex>
  );
};

export default SignedOfferBottomContainer;
